import Axios, { AxiosError } from "axios";
import {ActionCreator, Dispatch} from "redux";
import { ThunkAction } from "redux-thunk";
import { UserPreferencesAxios } from "../Contracts/Axios/UserPreferencesAxios";
import { IStore, ITerritoryType, IUserPreferences } from "../Models/Models";
import * as types from "./Types";

// GET
export const getUserPreferences: ActionCreator<
  ThunkAction<any, any, any, any>
> = () => {
    return (dispatch: Dispatch): void => {
        const userPreferencesAjax = new UserPreferencesAxios();
        const promises: Array<any> = [];
        promises.push(userPreferencesAjax.GetUserPreferences());

        Axios.all(promises)
            .then(
                Axios.spread((preferences: IUserPreferences) => {
                    dispatch(getUserPreferencesSuccess(preferences));
                })
            )
            .catch((error: AxiosError) => {
                dispatch(getUserPreferencesFailure(error));
            });
    };
};

// GET
export const getAllCommunitySites: ActionCreator<
  ThunkAction<any, any, any, any>
> = () => {
    return (dispatch: Dispatch): void => {
        const userPreferencesAjax = new UserPreferencesAxios();
        const promises: Array<any> = [];
        promises.push(userPreferencesAjax.GetAllCommunitySites());

        Axios.all(promises)
            .then(
                Axios.spread((sites: Array<IStore>) => {
                    dispatch(getAllCommunitySitesSuccess(sites));
                })
            )
            .catch((error: AxiosError) => {
                dispatch(getAllCommunitySitesFailure(error));
            });
    };
};

// UPDATE
export const updateUserPreferences: ActionCreator<
  ThunkAction<any, any, any, any>
> = (userPreferences: IUserPreferences) => {
    return (dispatch: Dispatch): void => {
        const userPreferencesAjax = new UserPreferencesAxios();
        const promises: Array<any> = [];
        if (!userPreferences.defaultLoginApp) {
            userPreferences.defaultLoginApp = "SCOUT";
        }
        promises.push(userPreferencesAjax.UpdateUserPreferences(userPreferences));

        Axios.all(promises)
            .then(
                Axios.spread((preferences: IUserPreferences) => {
                    dispatch(updateUserPreferencesSuccess(preferences));
                })
            )
            .catch((error: AxiosError) => {
                dispatch(updateUserPreferencesFailure(error));
            });
    };
};

// GET
export const getCompanyTerritoryTypes: ActionCreator<
  ThunkAction<any, any, any, any>
> = () => {
    return (dispatch: Dispatch): void => {
        const userPreferencesAjax = new UserPreferencesAxios();
        const promises: Array<any> = [];
        promises.push(userPreferencesAjax.GetCompanyTerritoryTypes());

        Axios.all(promises)
            .then(
                Axios.spread((territoryTypes: Array<ITerritoryType>) => {
                    dispatch(getCompanyTerritoryTypesSuccess(territoryTypes));
                })
            )
            .catch((error: AxiosError) => {
                dispatch(getCompanyTerritoryTypesFailure(error));
            });
    };
};

//------------------------------------------------ SUCCESS
const getUserPreferencesSuccess = (data: IUserPreferences) => ({
    type: types.GET_USER_PREFERENCES_SUCCESS,
    response: data,
});
const updateUserPreferencesSuccess = (data: IUserPreferences) => ({
    type: types.UPDATE_USER_PREFERENCES_SUCCESS,
    response: data,
});
const getAllCommunitySitesSuccess = (data: Array<IStore>) => ({
    type: types.GET_ALL_COMMUNITY_SITES_SUCCESS,
    response: data,
});
const getCompanyTerritoryTypesSuccess = (data: Array<ITerritoryType>) => ({
    type: types.GET_TERRITORY_TYPES_SUCCESS,
    response: data,
});
//------------------------------------------------ FAILURE
const getUserPreferencesFailure = (error: AxiosError) => ({
    type: types.GET_USER_PREFERENCES_FAILURE,
    response: error,
});
const updateUserPreferencesFailure = (error: AxiosError) => ({
    type: types.UPDATE_USER_PREFERENCES_FAILURE,
    response: error,
});
const getAllCommunitySitesFailure = (error: AxiosError) => ({
    type: types.GET_ALL_COMMUNITY_SITES_FAILURE,
    response: error,
});
const getCompanyTerritoryTypesFailure = (error: AxiosError) => ({
    type: types.GET_TERRITORY_TYPES_FAILURE,
    response: error,
});
